import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const nav = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    // Emergent OAuth returns #session_id=... after the redirect
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    // Clear the fragment so the token isn't visible in browser history
    if (window.history?.replaceState) {
      window.history.replaceState({}, "", window.location.pathname);
    }
    if (!sessionId) {
      setError("Missing Google session id. Please try signing in again.");
      return;
    }
    (async () => {
      try {
        const u = await googleSession(sessionId);
        if (u?.role_pending) {
          nav("/onboarding/role", { replace: true });
        } else {
          nav("/workspace", { replace: true });
        }
      } catch (e) {
        setError(e?.response?.data?.detail || e?.message || "Google sign-in failed.");
      }
    })();
  }, [googleSession, nav]);

  return (
    <div className="auth-shell" data-testid="auth-callback-page">
      <div className="auth-card">
        <img src="/logo.png" alt="GoPrintPack" className="auth-logo" style={{ margin: "0 auto 12px" }}/>
        {error ? (
          <>
            <h1>Sign-in issue</h1>
            <p className="auth-sub" data-testid="auth-callback-error">{error}</p>
            <a href="/login" className="primary-btn full" style={{ textAlign: "center", marginTop: 12 }} data-testid="auth-callback-retry">Back to sign in</a>
          </>
        ) : (
          <>
            <h1>Signing you in…</h1>
            <p className="auth-sub">Verifying your Google session with GoPrintPack™. This takes a moment.</p>
          </>
        )}
      </div>
    </div>
  );
}
